module.exports = `:root {
  --primitiveColorNeutral130: #222222;
  --primitiveColorNeutral430: #666666;
  --primitiveColorNeutral950: #f1f1f1;
  --primitiveColorNeutral1000: #ffffff;
  --primitiveColorBrandRed520: #ed1b2e;
  --primitiveColorBrandBlue220: #003767;
  --primitiveColorBrandGold820: #fec057;
  --primitiveColorBrandHealth620: #e270a7;
  --primitiveColorBlue310: #424a51;
  --primitiveColorBlue460: #0072b9;
  --primitiveColorBlue590: #009ada;
  --primitiveColorBlue850: #d1d6dc;
  --primitiveColorBlue960: #f0f4f7;
  --primitiveTypographyFontFamily: 'PT Sans', Arial, sans-serif;
  --primitiveTypographyTypescaleDesktop1: 3rem;
  --primitiveTypographyTypescaleDesktop2: 2.25rem;
  --primitiveTypographyTypescaleDesktop3: 1.375rem;
  --primitiveTypographyTypescaleDesktop4: 1.25rem;
  --primitiveTypographyTypescaleDesktop5: 1.125rem;
  --primitiveTypographyTypescaleDesktop6: 0.8125rem;
  --primitiveTypographyTypescaleMobile1: 2rem;
  --primitiveTypographyTypescaleMobile2: 1.5rem;
  --primitiveTypographyTypescaleMobile3: 1.375rem;
  --primitiveTypographyTypescaleMobile4: 1.25rem;
  --primitiveTypographyTypescaleMobile5: 1.125rem;
  --primitiveTypographyTypescaleMobile6: 0.8125rem;
  --primitiveTypographyTypescaleHelp: 1rem;
  --primitiveTypographyFontWeight: 400;
  --primitiveTypographyFontWeightBold: 700;
}
`;